/**
 * Created by DELL on 2018/7/5.
 */
import React from 'react'
import { Layout, Menu, Button, Icon } from 'antd'
import { withRouter } from 'react-router-dom'
import AppRoute from '../routes/app-route'
import RouteSubMenuList from '../compenents/RouteSubMenuList'
import { switchTabBarIndex, getCookie } from '../public/utils'
import common from '../public/common'
// 路由数组
const routeData = [
  [

    // {
    //   value: '总览',
    //   url: '/main/order/index'
    // },
    {
      name: '品牌社群列表',
      url: '/main/brandwx/list'
    },
    // {
    //   name: '订单列表',
    //   url: '/main/order/list'
    // },
    // {
    //   name: '超时未发货',
    //   url: '/main/order/overtimedelivery'
    // },
    // {
    //   name: '评价管理',
    //   urlArray: [
    //     {
    //       value: '服务评价',
    //       url: '/main/order/commentlist/servercomment'
    //     },
    //     {
    //       name: '商品评价',
    //       urlArray: [
    //         {
    //           value: '商品评价数据',
    //           url: '/main/order/commentlist/itemcommentlist/productcomment'
    //         },
    //         {
    //           value: '商品评价管理',
    //           url: '/main/order/commentlist/itemcommentlist/itemcomment'
    //         }
    //         // {
    //         //   value: '商品评价标签',
    //         //   url: '/main/order/commentlist/itemcommentlist/commenttag'
    //         // }
    //       ]
    //     }
    //   ]

    //   // name1: '商品评价',
    //   // urlArray1: [
    //   //   {
    //   //     value: '商品评价数据',
    //   //     url: '/main/order/productcomment'
    //   //   },
    //   //   {
    //   //     value: '商品评价管理',
    //   //     url: '/main/order/itemcomment'
    //   //   },
    //   //   {
    //   //     value: '商品评价标签',
    //   //     url: '/main/order/commenttag'
    //   //   }
    //   // ]

    // },
    // {
    //   name: '同城配镜订单列表',
    //   url: '/main/order/o2olist'
    // }

    // {
    //   value: '订单详情',
    //   url: '/main/order/listdetail'
    // },
    // {
    //   value: '订单统计',
    //   url: '/main/order/analysis'
    // },
    // {
    //   value: '缺货订单',
    //   url: '/main/order/outofstocklist'
    // },
    // {
    //   value: '取消订单',
    //   url: '/main/order/cancellist'
    // }

  ],

  [
    // {
    //   name: '首页',
    //   url: '/main/item/index'
    // },
    {
      name: '商品管理',
      urlArray: [
        {
          value: '商品列表',
          url: '/main/item/list/productlist'
        },
        {
          value: '组合商品',
          url: '/main/item/list/goodslist'
        }
        // {
        //   value: '商品类型',
        //   url: '/main/item/list/merchandisetype'
        // },
        // {
        //   value: '商品分类（前台）',
        //   url: '/main/item/list/commodity'
        // }
      ]
    },
    // {
    //   name: '品牌管理',
    //   url: '/main/item/brand'
    // },
    // {
    //   name: '资质管理',
    //   url: '/main/item/qualification'
    // },
    // {
    //   name: '商品标签',
    //   url: '/main/item/tag'
    // },
    // {
    //   name: '评价管理',
    //   urlArray: [
    //     {
    //       value: '商品评价',
    //       url: '/main/item/productcomment'
    //     },
    //     {
    //       value: '评价审核',
    //       url: '/main/item/commentreview'
    //     },
    //     {
    //       value: '评价标签',
    //       url: '/main/item/commenttag'
    //     }
    //   ]
    // },
    {
      name: '分类导航',
      url: '/main/item/navigation/classify'
    }, {
      name: '品牌管理',
      url: '/main/item/brandmanagement'
    },
    {
      name: '同城配镜',
      url: '/main/item/o2oproduct/productlist'
    }
    // {
    //   name: '商品成本',
    //   url: '/main/item/cost'
    // },
    // {
    //   name: '缺货商品',
    //   url: '/main/item/outofstocklist'
    // },
    // {
    //   name: '销量统计',
    //   url: '/main/item/sale'
    // }
  ],
  // 社区TAB
  [
    {
      name: '统计',
      url: '/main/socialcontact/content/statistics'
    },
    {
      name: '帖子',
      url: '/main/socialcontact/content/post'
    },
    {
      name: '评论',
      url: '/main/socialcontact/content/postcomment'
    },
    {
      name: 'PGC文章',
      url: '/main/socialcontact/content/pgclist/pgclist'
    },
    {
      name: '话题管理',
      url: '/main/socialcontact/content/topic'
    },
    {
      name: '马甲管理',
      url: '/main/socialcontact/content/account'
    },
    {
      name: '标签管理',
      url: '/main/socialcontact/content/tag'
    }
  ],
  // 内容TAB
  [
    {
      name: '站内资源位',
      urlArray: [
        {
          value: '投放内容管理',
          url: '/main/content/advertising/content-manage/list'
        },
        {
          value: '资源位管理',
          url: '/main/content/advertising/position-manage/list'
        }
      ]
    },
    {
      name: '友情链接',
      url: '/main/content/friendlylink/friendly-link'
    },
    {
      name: '商品推荐位',
      urlArray: [
        {
          value: '首页推荐位',
          url: '/main/content/itemfeaturedfirst/list'
        },
        {
          value: '彩片频道',
          url: '/main/content/product-recommend/color_contact'
        },
        {
          value: '透明片频道',
          url: '/main/content/product-recommend/clear_contact'
        },
        {
          value: '护理液频道',
          url: '/main/content/product-recommend/caresolution'
        }
      ]
    },
    {
      name: '网站公告',
      url: '/main/content/announcement'
    },
    {
      name: '帮助中心',
      url: '/main/content/helpcenter'
    },
    {
      name: '虚拟目录',
      url: '/main/content/virtuallist/virtual-list'
    },
    {
      name: '眼镜学堂',
      url: '/main/content/news'
    },
    {
      name: '搜索',
      urlArray: [
        {
          value: '热搜关键词',
          url: '/main/content/itemsearch/hotkeywords/hot-keywords'
        },
        {
          value: '搜索词配置',
          url: '/main/content/itemsearch/searchwordconfig/searchwordconfig'
        }
        // {
        //   value: '搜索关键词统计',
        //   url: '/main/content/itemsearch/keywords/key-words'
        // }
      ]
    },
    {
      name: '新人专区',
      urlArray: [
        {
          value: '新人商品推荐',
          url: '/main/content/newcomers'
        },
        {
          value: '新人券配置',
          url: '/main/content/newcomercoupon'
        }
      ]
    }
  ],

  [

    //   {
    //     name: '首页',
    //     url: '/main/marketing/index'
    //   },
    //   {
    //     name: '流量',
    //     urlArray: [
    //       {
    //         value: '流量',
    //         url: '/main/marketing/flow'
    //       }
    //     ]
    //   },
    //   {
    //     name: '促销',
    //     urlArray: [
    //       {
    //         value: '活动设置',
    //         url: '/main/marketing/promotion/activity'
    //       },
    //       {
    //         value: '规则设置',
    //         url: '/main/marketing/promotion/rule'
    //       }
    //     ]
    //   },
    {
      name: '优惠券',
      urlArray: [
        {
          value: '优惠券模板',
          url: '/main/marketing/coupon'
        },
        {
          value: '优惠券明细',
          url: '/main/marketing/couponusedetailmenu'
        }
      ]
    },

    {
      name: '金币商城',
      urlArray: [
        {
          value: '金币兑换优惠券',
          url: '/main/marketing/goldstore/couponrules/coupon-rules'
        },
        {
          value: '金币兑换商品',
          url: '/main/marketing/goldstore/commodityrules/commodity-rules'
        }
        // {
        //   value: '金币兑换明细',
        //   url: '/main/marketing/goldstore/gold-store'
        // }
      ]
    },
    {
      name: '拼购',
      urlArray: [
        {
          value: '拼购总览',
          url: '/main/marketing/pinbuy/pandect/pandect'
        },
        {
          value: '活动管理',
          url: '/main/marketing/pinbuy/management/management'
        },
        {
          value: '正在拼购',
          url: '/main/marketing/pinbuy/pinbuying/pinbuying'
        },
        {
          value: '已完成的',
          url: '/main/marketing/pinbuy/completed/completed'
        }
        // {
        //   value: '提取链接',
        //   url: '/main/marketing/pinbuy/extractlink'
        // }
      ]
    },
    {
      name: '营销通知',
      urlArray: [
        {
          value: '营销审核',
          url: '/main/marketing/groupmessage/check/check'
        },
        {
          value: '营销明细',
          url: '/main/marketing/groupmessage/check/checkdetailed/check-detailed'
        },
        {
          value: '生成营销链接',
          url: '/main/marketing/groupmessage/check/createlink'
        }

      ]
    },
    {
      name: '站外推广',
      urlArray: [
        {
          value: '推广活动',
          url: '/main/marketing/promotoutside/activitylist/activitylist'
        },
        {
          value: 'KOL账号',
          url: '/main/marketing/promotoutside/kolpage/kolpage'
        },
        {
          value: '结算申请',
          url: '/main/marketing/promotoutside/settlementapply/settlementapply'
        },
        {
          value: '付款申请',
          url: '/main/marketing/promotoutside/paymentapply/paymentapply'
        },
        {
          value: 'KOL费用变动表',
          url: '/main/marketing/promotoutside/kolfeechange/kolfeechange'
        }
      ]
    },
    {
      name: '兑奖活动',
      urlArray: [
        {
          value: '活动管理',
          url: '/main/marketing/redeemprize/prizemanagement'
        },
        {
          value: '组织者管理',
          url: '/main/marketing/redeemprize/organizer'
        },
        {
          value: '抽奖红包活动',
          url: '/main/marketing/redbagActivity/list'
        }
      ]
    },
    {
      name: '专题活动审核',
      url: '/main/marketing/activityAudit/activityAudit'
    }
  ],
  [
    {
      name: '推广会员',
      urlArray: [
        {
          value: '推广会员',
          url: '/main/marketinguser/list'
        },
        {
          value: '推广订单',
          url: '/main/marketinguser/orderlist'
        },
        {
          value: '提现管理',
          url: '/main/marketinguser/withdraw'
        }
      ]
    },
    {
      name: '通知管理',
      urlArray: [
        {
          value: '系统通知设置',
          url: '/main/marketinguser/notificationmanagement/notification-management'
        }
      ]
    },
    {
      name: '账号管理',
      url: '/main/accountManagement/accountManagement'
    },
    {
      name: '用户标签',
      url: '/main/usertags/usertags'
    }
  ],
  [
    {
      name: '业务对账',
      urlArray: [
        {
          value: '对账列表',
          url: '/main/finance/businessStatement'
        },
        {
          value: '订单对账明细',
          url: '/main/finance/orderReconciliationDetails'
        },
        // {
        //   value: '退款对账明细',
        //   url: '/main/finance/refundOrderDetails'
        // },
        {
          value: '退款对账明细',
          url: '/main/finance/refundOrderDetails'
        }
      ]
    },
    {
      name: '资金对账',
      urlArray: [
        {
          value: '对账列表',
          url: '/main/finance/financialAccounts/accountList'
        },
        {
          value: '订单对账明细',
          url: '/main/finance/financialAccounts/financialAccountsDetails'
        },
        // {
        //   value: '退款对账明细',
        //   url: '/main/finance/financialAccounts/refundOrderDetails'
        // },
        {
          value: '退款对账明细',
          url: '/main/finance/financialAccounts/refundOrderDetails'
        }
      ]
    }
  ],
  [
    {
      name: '问题与建议',
      urlArray: [
        {
          value: '处理队列',
          url: '/main/service/problemandsuggest/processqueue/processqueue'
        }
      ]
    }
  ],
  [
    {
      name: '数据导出',
      url: '/main/data/private-traffic'
    }
  ]
]

const { Header, Sider, Content } = Layout
class MainPageLayout extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      current: [],
      collapsed: false,
      routeModules: routeData[0],
      isIframe: false,
      showMobile: null
    }
  }
  componentDidMount () {
    let url = window.location.href
    if (url.indexOf('mobilepage') !== -1) {
      this.setState({
        showMobile: true
      })
    } else {
      this.setState({
        showMobile: false
      })
    }
    try {
      if (window.self === window.top && !(window.opener && window.opener.name === 'mainIframe')) {
        this.setState({
          isIframe: true
        })
      } else {
        window.localStorage.setItem('token', getCookie('localToken'))
        this.setState({
          isIframe: false
        })
      }
    } catch (err) {
      this.setState({
        isIframe: false
      })
    }

    const _index = switchTabBarIndex(window.location.href) + ''
    const current = this.state.current
    current.push(_index)
    this.setState({
      current: current,
      routeModules: routeData[_index - 1]
    })
  }
  toggleCollapsed = () => {
    this.setState({
      collapsed: !this.state.collapsed
    })
  }
  toggleModules = () => {
    window.location.href = common.admin_url + 'Home/Index'
  }
  toggleModules1 = (e) => {
    console.log(e)
    this.setState({
      routeModules: routeData[e.key - 1]
    })
    let firstLink = ''
    // 暂时默认显示第一个模块对应的第一个路由
    if (routeData[e.key - 1][0]['urlArray']) {
      firstLink = routeData[e.key - 1][0]['urlArray'][0]['url']
      this.props.history.push(firstLink)
    } else {
      firstLink = routeData[e.key - 1][0]['url']
      this.props.history.push(firstLink)
    }
    // const firstLink = routeData[e.key - 1][0]['urlArray'][0]['url']
    // this.props.history.push(firstLink)
  }
  render () {
    let { showMobile } = this.state
    return (
      showMobile === null ? null : showMobile ? <AppRoute />
        : <Layout>
          <Header className="header" style={ { display: this.state.isIframe ? '' : 'none' } }>
            <span className="logotitle">视客眼镜网 后台管理</span>
            <Menu
              theme="dark"
              mode="horizontal"
              defaultSelectedKeys={ this.state.current }
              style={ { lineHeight: '64px' } }
            >
              {/* <Menu.Item key="1" onClick={this.toggleModules}>订单</Menu.Item>
                */}
              <Menu.Item key="1" onClick={ this.toggleModules1 }>品牌</Menu.Item>
              {/*
              <Menu.Item key="9" onClick={ this.toggleModules1 }>数据</Menu.Item>
              <Menu.Item key="10" onClick={ this.toggleModules } >回到旧版本</Menu.Item>
              */}
              {/* <Menu.Item key="7" onClick={this.toggleModules}>报表</Menu.Item>
               <Menu.Item key="8" onClick={this.toggleModules}>管理员设置</Menu.Item>
               <Menu.Item key="9" onClick={this.toggleModules}>demo</Menu.Item> */}
            </Menu>
          </Header>
          <Layout style={ { padding: 24, margin: this.state.isIframe ? 24 : '', position: 'relative' } }>
            <Sider collapsed={ this.state.collapsed } width={ 200 } style={ { background: '#fff', display: this.state.isIframe ? '' : 'none' } }>
              <Button type="primary" onClick={ this.toggleCollapsed } style={ { marginBottom: 16 } }>
                <Icon type={ this.state.collapsed ? 'menu-unfold' : 'menu-fold' } />
              </Button>
              {/* <Menu
                 mode="inline"
                 defaultSelectedKeys={['首页&/main/user/index']}
                 defaultOpenKeys={['sub2']}
                 style={{ height: '100%' }}
               > */}
              <RouteSubMenuList collpsed={ this.state.collapsed } routeData={ this.state.routeModules } allRouter={ routeData } />
              {/* </Menu> */ }
            </Sider>
            <Layout style={ { padding: 24, background: '#fff' } }>
              <Content style={ { padding: 24, margin: 0, minHeight: 280 } }>
                <AppRoute />
              </Content>
            </Layout>
          </Layout>
        </Layout>
    )
  }
}
export default withRouter(MainPageLayout)



// WEBPACK FOOTER //
// ./src/layout/main-page-layout.js